export default __webpack_public_path__ + "static/media/SourceHanSansCN-Heavy.886c59ca.ttf";